import React from "react";


import { Icon } from "components/Icon";
import styled from "styled-components";

import { SMS_ACCOUNT_ID } from "const";


import { Dropdown, Loader } from "rsuite";

const NumbersDownloadDropdown = (
    {
        isTransitTrunks,
        disabled,
        loading,
        onDownloadNumbersCsv,
        onDownloadOnlyNumbersCsv,
        isMobile = false,
        account,

        ...props
    }
) => {

    return (
        <StyledDropdown
            isMobile={isMobile}
            title={<>{loading
                ? <StyledLoader />
                : isMobile ? <Icon icon={"download"} /> : "Download"}</>
            }
            appearance="default"
            placement="bottomStart"
            disabled={disabled}
            {...props}
        >
            <Dropdown.Item
                onClick={onDownloadNumbersCsv}
            >
                Download allocated {isTransitTrunks ? "prefixes" : "numbers"} as csv
            </Dropdown.Item>

            {account?.id !== SMS_ACCOUNT_ID &&
                <Dropdown.Item
                    onClick={onDownloadOnlyNumbersCsv}
                >
                    Download only {isTransitTrunks ? "prefixes" : "numbers"} (txt version)
                </Dropdown.Item>
            }
        </StyledDropdown>
    )
};

export default NumbersDownloadDropdown;

const StyledDropdown = styled(Dropdown)`    
    & > .rs-dropdown-toggle {
        padding: ${props => props.isMobile
        ? "8px 32px 8px 12px !important"
        : "12px 34px !important"
    };
        width: 100%;
    }
`;

const StyledLoader = styled(Loader)`
  & span.rs-loader-spin {
    margin-top: 3px;
    margin-right: 5px;
  }
`;
